(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["linked-product-swatches"] && !Shopify.designMode) return;
  try {
    class ProductSwatches extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.labelContent = this.querySelector('.linked-product-swatch__label-content');
            if (!this.labelContent) return;

            this.activeLabel = this.labelContent.textContent;

            this.querySelectorAll('.linked-product-swatch').forEach((swatch) => {
                swatch.addEventListener('mouseenter', () => this.showSwatchLabel(swatch));
                swatch.addEventListener('mouseleave', () => this.resetSwatchLabel());
            });
        }

        showSwatchLabel(swatch) {
            this.labelContent.textContent = swatch.getAttribute('title') || this.activeLabel;
        }

        resetSwatchLabel() {
            this.labelContent.textContent = this.activeLabel;
        }
    }

    customElements.define('product-swatches', ProductSwatches);
  } catch(e) { console.error(e); }
})();

})();
